import { i18n } from "@lingui/core";
import { messages as enMessages } from "../locales/en/messages";
import { messages as jaMessages } from "../locales/ja/messages";

i18n.load({
    en: enMessages,
    ja: jaMessages
});

export const detectUserLocale = (): string => {
    const savedLocale = localStorage.getItem("user-locale");
    if (savedLocale && ["en", "ja"].includes(savedLocale)) {
        return savedLocale as string;
    }

    const browserLocale = navigator.language || navigator.languages?.[0];

    if (browserLocale?.startsWith("ja")) {
        return "ja";
    };
    if (browserLocale?.startsWith("en")) {
        return "en";
    }
    return "en";
};

export const initializeI18n = () => {
    const locale = detectUserLocale();
    i18n.activate(locale);
    return locale;
}